import moment from 'moment'
import { DomainM, FormValuesCampaignForManager } from 'types/managerTypes'
import React from 'react'
import { CityI, SelectListT } from '../../../types/common'
import I from 'immutable'

const getJobIds = (jobs: Array<{ id?: number; value?: number }> = []) =>
  jobs
    .map((job: { id?: number; value?: number }) => job.value || job.id)
    .map((jobId: number | undefined) => Number(jobId))
    .filter((jobId: number) => !!jobId && !isNaN(jobId))

export const transformCampaignUpdateValues = (values: FormValuesCampaignForManager) => {
  const {
    name,
    createdAt,
    description,
    image,
    label,
    isPublic,
    city,
    proximity,
    chatPropertyId,
    chatWidgetId,
    expiresAt,
    skills,
    domains,
    jobs,
    campaignMatchingMode
  } = values
  const isJobsMode = campaignMatchingMode === 'jobs'
  const cityId = city ? city.value : null
  const proximityValue = cityId ? (proximity ? proximity : null) : null

  const payload = {
    name: name ? name : null,
    createdAt: createdAt || new Date(),
    image: image ? image : null,
    label: label ? label : null,
    description: description ? description : null,
    cityId: isJobsMode ? null : cityId,
    proximity: isJobsMode ? null : proximityValue,
    isPublic: isPublic ? isPublic : false,
    expiresAt: expiresAt && moment(expiresAt).startOf('day'),
    chatPropertyId: chatPropertyId ? chatPropertyId : null,
    chatWidgetId: chatWidgetId ? chatWidgetId : null,
    skills: isJobsMode
      ? null
      : skills &&
        Array.isArray(skills) &&
        skills
          .map(skill => skill.id || undefined)
          .filter(s => !!s)
          .join(','),
    domains: domains && domains.map(d => d.value)
  }

  if (isJobsMode) {
    return {
      ...payload,
      jobIds: getJobIds(jobs)
    }
  }

  return {
    ...payload,
    jobIds: []
  }
}

export function convertDomains(domains: DomainM[]): SelectListT {
  return I.fromJS(
    domains.map((domain: DomainM) => ({
      value: domain.id,
      label: domain.name
    }))
  )
}
